import styled, { css } from 'styled-components';
import {
    ColorAdvice3,
    ColorNeutralWhite,
    Spacing8,
    Spacing16,
    Spacing20,
    Spacing24,
    Spacing40,
    Spacing80
} from 'autogen/design-tokens/tokens';
import QuickView from 'components/quickView';
import { rem } from 'modules/helpers/style';
import { breakpoint, fonts, sizes } from 'variables';
import type { IToolboxTheme } from './types';

export const toolboxPadding = css`
    padding: ${Spacing24};

    ${breakpoint.up(sizes.md)} {
        padding: ${Spacing24} ${Spacing80} ${Spacing80};
    }
`;

export const StyledQuickView = styled(QuickView)<{ survey?: boolean }>`
    background-color: ${({ survey }) => (survey ? ColorNeutralWhite : ColorAdvice3)};
    height: calc(100% - 40px);
    max-height: none;

    ${breakpoint.up(sizes.md)} {
        width: 800px;
        height: auto;
        max-height: calc(100% - 40px);
        max-width: calc(100% - ${Spacing40});
    }
`;

export const Headline = styled.h2<{ theme: IToolboxTheme }>`
    font-weight: bold;
    font-size: ${({ theme }) => (theme.inline ? rem(20) : rem(24))};
    font-family: ${fonts.CustomFonts.DMSerifText};
    line-height: ${({ theme }) => (theme.inline ? 1 : 1.25)};
    margin: ${({ theme }) => (theme.inline ? `0 ${Spacing16} ${Spacing16}` : `0 0 ${Spacing16}`)};

    ${breakpoint.up(sizes.md)} {
        text-align: ${({ theme }) => (theme.inline ? 'center' : 'left')};
        font-size: ${({ theme }) => (theme.inline ? rem(28) : rem(24))};
        margin: ${({ theme }) => (theme.inline ? `0 ${Spacing16} ${Spacing16}` : `0 0 ${Spacing20}`)};
    }
`;

export const List = styled.ul`
    display: grid;
    grid-gap: ${Spacing8};
    grid-template-columns: repeat(auto-fit, minmax(min(150px, 50%), 1fr));
    list-style: none;
    margin: 0;
    padding: 0;
`;

export const Item = styled.li`
    display: flex;
    grid-column: 1 / -1;

    ${breakpoint.up(sizes.sm)} {
        grid-column: auto;

        &:first-child {
            grid-column: 1 / span 2;
        }
    }
`;
